<fisico-header></fisico-header>
  <main id="main">
    <div class="d-flex align-items-center justify-content-center contato-concluido mt-5 pt-5" style="min-height: 500px;">
        <div class="p-nav mt-5 pt-5 text-center">
            <h1 class="mt-5"><strong>Página não encontrada!</strong></h1>
            <p class="lead">
                Desculpe, mas a página que você tentou acessar não existe.
            </p>
            <p class="lead">
                Clique em <strong>Continuar</strong> para retornar a homepage!
            </p>
            <p class="text-center mt-3">
                <a href="/" [routerLink]="['/']" title="Continuar" class="">
                    <button class="button">Continuar</button>
                </a>
            </p>
        </div>
    </div>
  </main>
<fisico-footer></fisico-footer>